import React, { useEffect, useState } from "react";
import { Button, Space } from "antd";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../../config";
import { useTranslation } from "react-i18next";

const AppointmentButton = (props) => {

  const { t } = useTranslation();

  const { row, loginDoctorDetails, rejoinVisibleRowId, setRejoinVisibleRowId } =
    props;


  const patientID = row?.patient_details?.patient_viet_id;
  const navigate = useNavigate();
  const [isRejoining, setIsRejoining] = useState(false);
  useEffect(() => {
    if (
      row.status === "IN_PROGRESS" &&
      loginDoctorDetails.doctor_id === row.doctor_id
    ) {
      setRejoinVisibleRowId(row.id);
    }
  }, [row, loginDoctorDetails, setRejoinVisibleRowId]);

  const handleJoin = async (row) => {
    const { doctor_id } = loginDoctorDetails;
    const { id } = row;
    const data = {
      doctor_id,
      appointment_id: id,
      event: "JOIN",
      device_group: 0,
    };

    const headers = {
      "Content-Type": "application/json",
    };

    try {
      const response = await axios.post(
        `${API_URL}/appointment/doctor_event/`,
        data,
        { headers },
      );
      const teleconsultApiUrl = `${API_URL}/teleconsult/v2/doctor/`;
      const teleconsultData = {
        doctor_id: response.data.doctor_id,
      };

      const teleconsultResponse = await axios.post(
        teleconsultApiUrl,
        teleconsultData,
        { headers },
      );
      const doctorVideoCallToken = teleconsultResponse.data.token;
      localStorage.setItem("doctorToken", doctorVideoCallToken);


      navigate("/video-call", {
        state: {
          doctorVideoCallToken,
          doctorId: doctor_id,
          appointmentId: id,
          patientRowId: patientID,
          rowData: row,
        },
      });
    } catch (error) {
      console.error("Error joining appointment:", error);
      if (error.response) {
        console.error("Error details:", error.response.data);
      }
    }
  };

  const handleRejoin = (row) => {
    navigate("/video-call", {
      state: {
        doctorVideoCallToken: localStorage.getItem("doctorToken"),
        doctorId: loginDoctorDetails?.doctor_id,
        appointmentId: row?.id,
        patientRowId: patientID,
        rowData: row,
        isRejoining: true,
      },
    });
  };

  const handleCancel = async () => {
    const { doctor_id } = loginDoctorDetails;
    const { id } = row;
    const data = {
      doctor_id,
      appointment_id: id,
      event: "END",
      device_group: 0,
    };

    const headers = {
      "Content-Type": "application/json",
    };

    try {
      await axios.post(`${API_URL}/appointment/doctor_event/`, data, {
        headers,
      });
      localStorage.removeItem("doctorToken");
      sessionStorage.removeItem("appointmentId");
      sessionStorage.removeItem("doctorId");
      sessionStorage.removeItem("patientRowId");
      sessionStorage.removeItem("rowData");

      setRejoinVisibleRowId(null);
    } catch (error) {
      console.error("Error ending appointment:", error);
      if (error.response) {
        console.error("Error details:", error.response.data);
      }
    }
  };

  const shouldShowJoinButton = row.status === "IN_PROGRESS" && row.video;
  const shouldShowRejoinButton =
    row.status === "IN_PROGRESS" &&
    loginDoctorDetails.doctor_id === row.doctor_id;

  return (
    <Space wrap>
      {shouldShowJoinButton && rejoinVisibleRowId !== row.id && (
        <Button
          type="primary"
          onClick={() => handleJoin(row)}
          disabled={rejoinVisibleRowId !== null}
          style={{
            borderColor: rejoinVisibleRowId !== null ? "green" : "",
            color: rejoinVisibleRowId !== null ? "green" : "",
          }}
        >
          {rejoinVisibleRowId !== null ? t("patientPage.inProgress") : t("patientPage.join")}
        </Button>
      )}
      {shouldShowRejoinButton && rejoinVisibleRowId === row.id && (
        <>
          <Button type="primary" onClick={() => handleRejoin(row)}>
            {t("patientPage.reJoin")}
          </Button>
          <Button type="primary" danger onClick={handleCancel}>
            {t("patientPage.end")}
          </Button>
        </>
      )}
    </Space>
  );
};

export default AppointmentButton;
